module.exports = __webpack_public_path__ + "static/logo-401eb56e83ed3b9df75d6c44ba96c7ea.png";